const R = require('ramda');
const utils = require('./utils');
const _ = require('lodash');
const colorNamer = require('color-namer');
const { metrics: MetricsLocale } = require('../../locale');
const {
  CONVERSION_TYPES,
  TRACKER_LIST_FOR_FE,
  COMMON_BASIC_COLUMNS_FOR_FE,
  VALID_CONVERSION_PREFIX,
  CONVERT_NEEDED_TRACKERS,
  ANALYTICS_PREFIX,
  DATE_GROUP_ROWS
} = require('../constants');

/**
 *
 * @param {Report} report
 * @param {ArchitectureElement} element
 */
function getMetricFromReport(report, element) {
  const { metric } = getMetricAndConversionFromReport({ report, element });
  return metric;
}

/**
 *
 * @param {Report} report
 * @param {ArchitectureElement} element
 */
function getMetricAndConversionFromReport({ report, element }) {
  const metric = R.omit(['conversions'], report.metric);
  let metricObj = metric;
  const actions = report.actions;
  if (metric.hasOwnProperty('videoViews')) {
    metric.spendOnViews = metric.spend;
    metric.videoImpressions = metric.impressions;
  }
  if (element.isLifeTimeBudget) {
    metric.lifeTimeSpend = metric.spend;
    if (element.lifeTimeBudget) metric.lifeTimeBudget = element.lifeTimeBudget;
  }
  const campaign = element.campaign;
  if (element.isArchitectureLevel) {
    if (element.isFacebook) {
      metric.facebookSpend = metric.spend;
    }
    if (campaign && (campaign.isConversion || campaign.isAdrielLeadForm)) {
      const spendOnActions = metric.spend;
      const clicksOnActions = metric.clicks;
      const leads = metric.leads;
      let conversions = 0;
      // if lead campaign we consider the leads as conversions
      if (leads != null) {
        conversions = leads;
      } else {
        // we find the nb of conversions in the actions
        if (campaign.isConversion) {
          if (actions) {
            const conversionGoal = campaign.getConversionGoal();
            if (conversionGoal) {
              const goal = actions.find(action => action.key === conversionGoal || action.name === conversionGoal);
              if (goal) conversions = goal.value;
            }
          }
        }
      }

      metricObj = {
        ...metric,
        conversions,
        spendOnActions,
        clicksOnActions,
      };
    }
  }

  let conversionsByTracker;
  if (actions && actions.length > 0) {
    const purchaseActions = actions.filter(
      action =>
        action.actionValue != null &&
        (action.name === 'purchase' ||
          (['google', 'naver', 'amazon', 'microsoft', 'snapchat', 'criteo'].includes(element.channel) &&
            action.name === 'Conversions')),
    );
    if (purchaseActions.length > 0) {
      metricObj.pixelRevenue = purchaseActions.reduce((acc, { actionValue }) => acc + (actionValue || 0), 0);
    }
    conversionsByTracker = utils.getConversionsByTracker(actions);
    const totalConversionsByTracker = Object.entries(conversionsByTracker).reduce((obj, [tracker, actions]) => {
      obj[tracker] = actions.reduce((sum, { value }) => sum + (value || 0), 0);
      return obj;
    }, {});
    // TODO check if zero or null when we can know if we pixel is linked or not
    if (totalConversionsByTracker['pixel']) {
      metricObj.totalPixelConversions = totalConversionsByTracker['pixel'];
    }
    if (totalConversionsByTracker['ga']) {
      metricObj.totalGAConversions = totalConversionsByTracker['ga'];
    }

    metricObj.totalOtherConversions =
      (totalConversionsByTracker['mobile'] || 0) + (totalConversionsByTracker['lead'] || 0);

    if (totalConversionsByTracker['google_reports']) {
      metricObj.totalGoogleAdsConversions = totalConversionsByTracker['google_reports'];
    }
    if (totalConversionsByTracker['naver_reports']) {
      metricObj.totalNaverConversions = totalConversionsByTracker['naver_reports'];
    }
    if (totalConversionsByTracker['twitter_reports']) {
      metricObj.totalTwitterConversions = totalConversionsByTracker['twitter_reports'];
    }
    if (totalConversionsByTracker['tiktok_reports']) {
      metricObj.totalTiktokConversions = totalConversionsByTracker['tiktok_reports'];
    }
    if (totalConversionsByTracker['kakao_pixel']) {
      metricObj.totalKakaoConversions = totalConversionsByTracker['kakao_pixel'];
    }
    if (totalConversionsByTracker['microsoft_reports']) {
      metric.totalMicrosoftConversions = totalConversionsByTracker['microsoft_reports'];
    }
    if (totalConversionsByTracker['linkedin_reports']) {
      metric.totalLinkedinConversions = totalConversionsByTracker['linkedin_reports'];
    }
    if (totalConversionsByTracker['amazon_reports']) {
      metric.totalAmazonConversions = totalConversionsByTracker['amazon_reports'];
    }
    if (totalConversionsByTracker['snapchat_reports']) {
      metric.totalSnapchatConversions = totalConversionsByTracker['snapchat_reports'];
    }
    if (totalConversionsByTracker['criteo_reports']) {
      metric.totalCriteoConversions = totalConversionsByTracker['criteo_reports'];
    }
    if (totalConversionsByTracker['navergfa_reports']) {
      metric.totalNAverGFAConversions = totalConversionsByTracker['navergfa_reports'];
    }
  }

  // it is written pixel but it is not only for pixel, it is too troublesome to change
  if (metric.pixelRevenue == null) {
    // naver use convAmt
    metric.pixelRevenue = metric.convAmt;
  }
  // if (
  //     metric.pixelRevenue == null &&
  //     actions &&
  //     actions.length > 0 &&
  //     actions[0].actionValue != null
  // ) {
  //     metric.pixelRevenue = actions[0].actionValue;
  // }

  return {
    ...R.omit(['metric', 'actions', 'action_values', 'level'], report),
    metric: metricObj,
    conversionsByTracker,
  };
}

/**
 *
 * @param {Array} metricAndConversionList
 */
function mergeMetricAndConversion(metricAndConversionList) {
  if (metricAndConversionList.length === 0) return {};
  if (metricAndConversionList.length === 1) return metricAndConversionList[0];
  let mergedMetric = {};
  let mergedConversionsByTracker = {};
  metricAndConversionList.forEach(({ metric, conversionsByTracker }) => {
    mergedMetric = utils.sumObject(mergedMetric, metric);
    mergedConversionsByTracker = utils.mergeConversionsByTracker([mergedConversionsByTracker, conversionsByTracker]);
  });

  return {
    ...R.omit(['metric', 'conversionsByTracker'], metricAndConversionList[0]),
    metric: mergedMetric,
    conversionsByTracker: mergedConversionsByTracker,
  };
}

const EXTRA_METRIC_TO_ADD = [
  'spendOnActions',
  'clicksOnActions',
  'facebookSpend',
  'spendOnViews',
  'lifeTimeBudget',
  'lifeTimeSpend',
];

function getMetricAndConversions({ element, dateGroup, detail }) {
  const reports = element.getReports({ dateGroup, detail });
  const metricsAndConversions = [];
  reports.forEach(report => {
    const metric = Object.assign({}, report.metric);
    const conversionsByTracker = {};
    if (element.isFacebook) {
      metric.facebookSpend = metric.spend;
    }
    if (element.isLifeTimeBudget) {
      metric.lifeTimeSpend = metric.spend;
      if (element.lifeTimeBudget) metric.lifeTimeBudget = element.lifeTimeBudget;
    }
    metricsAndConversions.push({ metric, conversionsByTracker });
  });
  return metricsAndConversions;
}

function getMetricValue({ name, metricObj, formatValue = false, isConversion = false }) {
  let value = null;
  if (isConversion) {
    return {
      tracker: metricObj.tracker,
      name: metricObj.name,
      value: metricObj.value,
    };
  }
  if (name === 'cpc') {
    const { clicks, spend } = metricObj;
    if (clicks == null || spend == null) return undefined;
    if (!clicks) return null;
    value = spend / clicks;
  } else if (name === 'ctr') {
    const { clicks, impressions } = metricObj;
    if (clicks == null || impressions == null) return undefined;
    if (!impressions) return null;
    value = clicks / impressions;
  } else if (name === 'cpm') {
    const { impressions, spend } = metricObj;
    if (!impressions) return null;
    value = (spend / impressions) * 1000;
  } else if (name === 'cpa') {
    let { conversions, spendOnActions } = metricObj;
    if (conversions == null) conversions = metricObj.value;
    if (conversions == null || spendOnActions == null) return undefined;
    if (!conversions) {
      value = null;
    } else value = spendOnActions / conversions;
  } else if (name === 'conversionRate') {
    let { conversions, clicksOnActions } = metricObj;
    if (conversions == null) conversions = metricObj.value;
    if (clicksOnActions == null || conversions == null) return undefined;
    if (!conversions) {
      value = null;
    } else value = conversions / clicksOnActions;
  } else if (name === 'bounceRate') {
    const { bouncedVisits, visits } = metricObj;
    if (visits == null || bouncedVisits == null) return undefined;
    if (!visits) {
      value = null;
    } else value = bouncedVisits / visits;
  } else if (name === 'visitDuration') {
    const { totalVisitDuration, visits } = metricObj;
    if (visits == null || totalVisitDuration == null) return undefined;
    if (!visits) {
      value = null;
    } else value = totalVisitDuration / visits;
  } else if (name === 'visitDurationWithOutBounce') {
    const { totalVisitDuration, visits, bouncedVisits } = metricObj;
    const noBouncedVisits = visits - bouncedVisits;
    if (noBouncedVisits == null || totalVisitDuration == null) return undefined;
    if (!noBouncedVisits) {
      value = null;
    } else value = totalVisitDuration / noBouncedVisits;
  } else if (name === 'pageViews') {
    const { totalPageViews, visits } = metricObj;
    if (visits == null || totalPageViews == null) return undefined;
    if (!visits) {
      value = null;
    } else value = totalPageViews / visits;
  } else if (name === 'frequency') {
    const { reach, impressions } = metricObj;
    if (!reach) {
      value = null;
    } else value = impressions / reach;
  } else if (name === 'pixelRoas') {
    const { pixelRevenue, facebookSpend, spend } = metricObj;
    if (!(facebookSpend || spend) || pixelRevenue == null) {
      return undefined;
    } else value = pixelRevenue / (facebookSpend || spend);
  } else if (name === 'gaRoas') {
    const { gaRevenue, spend } = metricObj;
    if (!spend || gaRevenue == null) {
      return undefined;
    } else value = gaRevenue / spend;
  } else if (name === 'videoViewsRate') {
    const { videoImpressions, videoViews } = metricObj;
    if (!videoImpressions) return undefined;
    value = videoViews / videoImpressions;
  } else if (name === 'cpv') {
    const { videoViews, spendOnViews } = metricObj;
    if (!videoViews) return undefined;
    value = spendOnViews / videoViews;
  } else if (name === 'amountSpentPercentage') {
    const { lifeTimeSpend, lifeTimeBudget } = metricObj;
    if (!lifeTimeBudget || lifeTimeSpend == null) return undefined;
    value = lifeTimeSpend / lifeTimeBudget;
  } else if (name.startsWith('cpa:')) {
    let conversionName = name.substr(4);
    let conversions = metricObj['conversions:' + conversionName];
    let spendOnActions = metricObj['spendOnActions:' + conversionName];
    if (!conversions) return undefined;
    value = spendOnActions / conversions;
  } else if (name.startsWith('conversionRate:')) {
    let conversionName = name.substr(15);
    let conversions = metricObj['conversions:' + conversionName];
    let clicksOnActions = metricObj['clicksOnActions:' + conversionName];
    if (!clicksOnActions) return undefined;
    value = conversions / clicksOnActions;
  }
  if (value == null) value = metricObj[name];
  if (formatValue) {
    return formatMetricValue(name, value);
  } else return value;
}

const METRIC_TO_METRIC_TYPE = {};
function init_METRIC_TO_METRIC_TYPE() {
  for (let name of [
    'spend',
    'dailyBudget',
    'lifeTimeBudget',
    'fee',
    'totalDailyBudget',
    'adSpent',
    'cpc',
    'cpv',
    'cpa',
    'cpm',
    'gaRevenue',
    'pixelRevenue',
    'bidCap',
    'pixelRevenue',
    'gaRevenue',
    'cpr',
    'conversionsValue',
    'conversionValue',
    'costPerMessagingFirstReply',
    'costPerMessagingStarted7d',
    'costPerOutboundClick',
    'dailyBudgetAmount',
    'spendWithVat',
    'spendWithMarkup',
  ]) {
    METRIC_TO_METRIC_TYPE[name] = 'price';
  }
  for (let name of ['visitDuration', 'visitDurationWithOutBounce']) {
    METRIC_TO_METRIC_TYPE[name] = 'time';
  }
  for (let name of [
    'status',
    'objectives',
    'subChannels',
    'id',
    'campaignId',
    'adSetId',
    'adId',
    'adName',
    'name',
    'appPlatforms',
    'campaignName',
    'adSetName',
    'adAccountName',
    'targetingType',
    'bidStrategy',
    'conversionEvent',
    'accountName',
    'level',
    'resultIndicator',
    'channelSubType',
    'matchingType',
    'channelAdAccountId',
    'keywordName',
    'channelKeywordId',
    'campaignStatus',
    'adSetStatus',
    'adStatus',
    'conversionGoal',
  ]) {
    METRIC_TO_METRIC_TYPE[name] = 'string';
  }
  for (let name of [
    'bounceRate',
    'ctr',
    'conversionRate',
    'gaRoas',
    'pixelRoas',
    'roas',
    'amountSpentPercentage',
    'videoViewsRate',
    'cvr',
    'outboundClicksCtr',
  ]) {
    METRIC_TO_METRIC_TYPE[name] = 'percentage';
  }
  for (let name of ['placements', 'budget']) {
    METRIC_TO_METRIC_TYPE[name] = 'object';
  }

  for (let name of ['conversionEvents', 'bidStrategies']) {
    METRIC_TO_METRIC_TYPE[name] = 'array';
  }

  for (let name of ['starts', 'ends']) {
    METRIC_TO_METRIC_TYPE[name] = 'date';
  }

  for (let name of ['results']) {
    METRIC_TO_METRIC_TYPE[name] = 'number';
  }
}
init_METRIC_TO_METRIC_TYPE();

/**j
 *
 * @param {string} metricName, ex: cpc, spend, budget
 * @returns {'object'|'array'|'price'|'time'|'percentage'|'string'|'conversion'|'number'}
 */

function getCellType(cellName, subType) {
  if (!cellName) return 'string';

  const type = METRIC_TO_METRIC_TYPE[cellName];

  if (type) return type;

  const lowerCasedCellName = cellName.toLowerCase();

  if (lowerCasedCellName.includes('utm')) {
    METRIC_TO_METRIC_TYPE[cellName] = 'string';
  } else if (cellName.indexOf('cpa:') == 0 || cellName.indexOf('cpaWithTotalSpend:') === 0) {
    METRIC_TO_METRIC_TYPE[cellName] = 'price';
  } else if (cellName.indexOf('conversionRate:') == 0 || cellName.indexOf('bounceRate') > 0) {
    METRIC_TO_METRIC_TYPE[cellName] =
      cellName.startsWith('ga:') || cellName.startsWith('af:') ? 'parsedPercentage' : 'percentage';
  } else if (
    lowerCasedCellName.indexOf('sessionduration') > -1 ||
    lowerCasedCellName.endsWith('duration') ||
    lowerCasedCellName.indexOf('videoavgtime') > -1
  ) {
    METRIC_TO_METRIC_TYPE[cellName] = 'time';
  } else if (
    lowerCasedCellName.indexOf('conversionvalues:') == 0 ||
    lowerCasedCellName.indexOf('conversionvalue:') == 0
  ) {
    METRIC_TO_METRIC_TYPE[cellName] = 'price';
  } else if (lowerCasedCellName.indexOf('frequency') > -1) {
    METRIC_TO_METRIC_TYPE[cellName] = 'fullNumber';
  }
  return METRIC_TO_METRIC_TYPE[cellName];
}

function formatMetricValue(name, value) {
  if (value == null) return null;
  const type = getCellType(name);
  if (type === 'price' || type === 'time' || type === 'percentage') {
    return parseFloat(value.toFixed(2));
  }
  return value;
}

function getComputedMetricFromReport({ report, metricList }) {
  const { metric, conversionsByTracker } = getMetricAndConversionFromReport({
    report,
  });
  return getComputedMetric({ metric, metricList, conversionsByTracker });
}

function getComputedMetric({ metric, metricList, conversionsByTracker }) {
  const computedMetric = metricList.reduce((acc, metricName) => {
    const value = getMetricValue({ name: metricName, metricObj: metric });
    if (value != null) {
      acc[metricName] = value;
    }
    return acc;
  }, {});

  if (conversionsByTracker) {
    Object.entries(conversionsByTracker).forEach(([tracker, events]) => {
      events.forEach(event => {
        const conversionKey = `conversions:${tracker}:${event.name}`;
        const cpaKey = `cpa:${tracker}:${event.name}`;
        const conversionRateKey = `conversionRate:${tracker}:${event.name}`;
        const conversionValueKey = `conversionValue:${tracker}:${event.name}`;

        computedMetric[conversionKey] = event.conversions !== undefined ? event.conversions : event.value;
        computedMetric[`spendOnActions:${tracker}:${event.name}`] = event.spendOnActions;
        computedMetric[`clicksOnActions:${tracker}:${event.name}`] = event.clicksOnActions;
        computedMetric[conversionValueKey] = event.actionValue;

        const attributionWindowsValues = ['1d_view', '1d_click', '7d_view', '7d_click', '28d_view', '28d_click'];
        for (const attributionWindowsValue of attributionWindowsValues) {
          if (tracker == 'pixel') {
            const key = `conversions:${tracker}:${event.name}:${attributionWindowsValue}`;
            computedMetric[key] = event[attributionWindowsValue];
          }
        }

        computedMetric[cpaKey] = getMetricValue({
          name: 'cpa',
          metricObj: event,
        });
        computedMetric[conversionRateKey] = getMetricValue({
          name: 'conversionRate',
          metricObj: event,
        });
      });
    });
  }
  return computedMetric;
}

/**
 *
 * @param {string} cellName
 * @return {{metric: string, tracker: string, eventName: string}} info
 */
function getConversionCellInfo(cellName) {
  cellName = cellName || '';
  if (!R.is(String, cellName)) {
    cellName = String(cellName);
  }
  const [metric, tracker, eventName, etc] = R.compose(
    R.filter(R.identity),
    // for url check(exclude 'http(s)://')
    R.split(/:(?!\/\/|\s)/g),
  )(cellName);

  return {
    metric,
    tracker,
    eventName,
    etc,
  };
}

function getMergedCellFromCampaigns({ campaigns, availableMetrics }) {
  const metricAndConversionList = campaigns.map(campaign => ({
    metric: campaign.metric,
    conversionsByTracker: campaign.getConversionsByTracker(),
  }));
  const { metric, conversionsByTracker } = mergeMetricAndConversion(metricAndConversionList);
  const computedMetric = getComputedMetric({
    metric,
    conversionsByTracker,
    metricList: availableMetrics,
  });
  // get unique subChannels
  const subChannels = Array.from(new Set(campaigns.flatMap(campaign => campaign.subChannels)));
  return {
    ...computedMetric,
    subChannels,
  };
}

function getMetricFormula(metric) {
  const fctByOperation = {
    division: (left, right) => {
      if (left == null || right == null) return undefined;
      if (!right) return null;
    },
    division100: (left, right) => {
      if (!right) return null;
      return (left / right) * 100;
    },
    division1000: (left, right) => {
      if (!right) return null;
      return (left / right) * 1000;
    },
  };
  const formula = {
    right: null,
    left: null,
    operation: null,
    fct: null,
  };
  switch (metric) {
    case 'cpc':
      formula.left = 'spend';
      formula.right = 'clicks';
      formula.operation = 'division';
      break;
    case 'ctr':
      formula.left = 'clicks';
      formula.right = 'impressions';
      formula.operation = 'division100';
      break;
    case 'cpm':
      formula.left = 'spend';
      formula.right = 'impressions';
      formula.operation = 'division1000';
    case 'cpv':
      formula.left = 'spendOnViews';
      formula.right = 'videoViews';
      formula.operation = 'division';
    default:
      return null;
  }
  formula.fct = fctByOperation[formula.operation];
  return formula;
}

function convertClickViewDurationText(text = '') {
  if (R.isEmpty(text)) return '';

  const capitalize = (string = '') => string.charAt(0).toUpperCase() + string.slice(1);

  const [duration, action] = text.split('_');

  const convertedDuration = duration.replace(/[^0-9.]/g, '');
  const convertedACtion = capitalize(action);

  return `(${convertedACtion}, ${convertedDuration} day)`;
}

const upperHead = R.compose(R.converge(R.concat, [R.compose(R.toUpper, R.head), R.tail]), R.defaultTo(''));

const refineAnalyticMetrics = R.compose(
  R.ifElse(
    R.all(v => R.equals(R.toUpper(v), v)),
    R.identity,
    R.compose(
      R.join(''),
      ([fisrt, rest]) => [
        R.toUpper(fisrt),
        R.replace(
          /[A-Z]/g,
          (v, idx, full) => {
            if (idx > 0) {
              const before = full[idx - 1];
              const maybeNumber = R.is(Number, Number(before));
              const isBeforeUpperCase = R.toUpper(before) === before;

              return !maybeNumber || isBeforeUpperCase ? v : ` ${v}`;
            } else {
              return v;
            }
          },
          rest,
        ),
      ],
      R.splitAt(1),
    ),
  ),
  R.defaultTo(''),
);

const convertBlendedAnalyticMetric = ({ metric, tracker, eventName, localeObject }) => {
  const prefix = upperHead(metric);
  const event = eventName ? `${eventName}: ` : '';
  const additionals = localeObject[tracker] || refineAnalyticMetrics(tracker);
  return `${prefix}: ${event}${additionals}`;
}

const convertAnalyticMetricAtMarketing = ({ metric, tracker, eventName, etc, localeObject }) => {
  const prefix = localeObject[`conversion_${metric || ''}`] ||upperHead(metric);

  let event = localeObject[tracker] || refineAnalyticMetrics(tracker);

  let property = eventName ? `: ${eventName} ` : '';

  if (etc) {
    event = property ? `: ${event}${property}` : `${event}: `;
    property = etc;
  }

  return `${prefix}: ${event}${property}`;
}

function convertMetricNameToPivotTableFormat({ text, lang, localeObject }) {
  let [metric, tracker, eventName, etc = ''] = text.split(':');

  // for blended metric
  if (ANALYTICS_PREFIX.has(metric)) {
    return convertBlendedAnalyticMetric({ metric, tracker, eventName, localeObject });
  }

  if (CONVERT_NEEDED_TRACKERS.has(metric)) {
    return convertAnalyticMetricAtMarketing({ metric, tracker, eventName, etc, localeObject })
  }

  if (!tracker) {
    console.error('no tracker found', { text });
  }

  const prefix = localeObject[`conversion_${tracker || ''}`] || upperHead(tracker);

  eventName = R.propOr(eventName, eventName, localeObject);

  let displayedEtc = '';

  if (metric.endsWith('cpa')) {
    displayedEtc += ': CPA';
  } else if (metric.endsWith('conversionRate')) {
    displayedEtc += ': CVR';
  } else if (metric.endsWith('roas')) {
    displayedEtc += ': ROAS';
  } else if (metric.endsWith('conversionValues') || metric.endsWith('conversionValue')) {
    displayedEtc += `: ${localeObject['conversionValues']}`;
  } else if (metric.endsWith('cpaWithTotalSpend')) {
    displayedEtc += `: CPA (${localeObject['cpa_with_total']})`;
  }

  return `${prefix}: ${eventName} ${displayedEtc || ''}`;
}

const TRACKERS = Object.freeze({
  ga: 'GA',
  naver_reports: 'Naver',
  twitter_reports: 'Twitter',
  tiktok_reports: 'Tiktok',
  google_reports: 'Google Ads',
  kakao_pixel: 'Kakao',
  googleAnalytics: 'Google Analytics',
  microsoft_reports: 'Microsoft',
  linkedin_reports: 'Linkedin',
  amazon_reports: 'Amazon',
  snapchat_reports: 'Snapchat',
  criteo_reports: 'Criteo',
  navergfa_reports: 'NaverGFA',
});

function convertTextWhenMetricTextIsEmpty({ text, lang }) {
  const localeObject = MetricsLocale[lang];
  let [tracker, ...conversion] = text.split(':');
  conversion = conversion.join(':');

  tracker = R.propOr(utils.upperWords(tracker), tracker)(TRACKERS);
  tracker = localeObject[tracker.toLowerCase()] ? localeObject[tracker.toLowerCase()] : tracker;

  if (tracker.toLowerCase() === 'pixel' && conversion.indexOf(':') > -1) {
    let [name, clickPeriodOrViewName = ''] = conversion.split(':');

    const windowAttributionList = ['1d_view', '1d_click', '7d_view', '7d_click'];

    const hasPeriod = windowAttributionList.indexOf(clickPeriodOrViewName) > -1;

    const formattedViewName = hasPeriod ? convertClickViewDurationText(clickPeriodOrViewName) : clickPeriodOrViewName;

    return `${tracker}: ${name} ${formattedViewName}`;
  } else if (conversion.indexOf(':') > -1) {
    let [name, ...rest] = conversion.split(':');

    return `${tracker}: ${name}: ${rest.join('')}`;
  } else {
    conversion = R.propOr(conversion, R.toLower(conversion))(localeObject);

    return `${tracker}: ${conversion}`;
  }
}

function getMarketingSoueceMetricName({ text = '', lang = 'ko' }) {
  const localeObject = MetricsLocale[lang];
  if (text.indexOf(':') > -1) {
    const { metric, tracker } = getConversionCellInfo(text);

    if (tracker) {
      if (CONVERSION_TYPES.has(metric)) {
        return convertMetricNameToPivotTableFormat({ text, lang, localeObject });
      }

      return convertAnalyticMetricAtMarketing({ text, lang, localeObject });
    }

    return localeObject[text] || text;
  } else {
    return localeObject[text] || text;
  }
}

function getCustomSoueceMetricName({ text = '', lang = 'ko' }) {
  const localeObject = MetricsLocale[lang];
  let { metric, tracker = '', eventName } = getConversionCellInfo(text);

  if (!tracker) {
    return localeObject[metric] || refineAnalyticMetrics(metric);
  }

  const trackerSplitted = R.split('__', tracker);
  if (trackerSplitted.length === 2) {
      const [breakdown, metric] = trackerSplitted;
      tracker = breakdown;
      eventName = localeObject[metric] || refineAnalyticMetrics(metric);
  }

  const later =
    metric === 'gss'
      ? tracker
      : DATE_GROUP_ROWS.includes(tracker)
      ? refineAnalyticMetrics(tracker)
      : localeObject[tracker] || refineAnalyticMetrics(tracker);

  let refined = `${upperHead(metric)}: ${later}`;

  if (eventName) {
    refined += `: ${eventName}`;
  }

  return refined;
}

function countUniqueChildQuery(row) {
  if (!row.childQueries) {
    return 0;
  }

  const list = _.uniq(
    row.childQueries
      .map(q => {
        const found = q.where.find(elem => elem.field === 'channelId' && elem.level === 'ad') || {};
        return found.values;
      })
      .flat()
      .filter(v => v),
  );

  return list.length;
}

// ad copy
function getWordCloudList(rows, metric = 'ctr') {
  rows = rows.filter(r => r.cell[metric]);
  const totalRowsWordCount = rows.map(countUniqueChildQuery).reduce((a, b) => a + b, 0);
  let wordCloudList = [];
  for (let row of rows) {
    // const wordOccurrences = countUniqueChildQuery(row);
    let totalWordCount;
    let wordOccurrences;
    if (row.childQueries) {
      wordOccurrences = countUniqueChildQuery(row);
      totalWordCount = totalRowsWordCount;
    } else {
      wordOccurrences = row.cell.wordOccurrences;
      totalWordCount = row.cell.wordTotalCount;
    }
    const wordTf = Number(wordOccurrences) / Number(totalWordCount) || 0;
    const choosenMetric = Number(row.cell[metric]) || 0;
    wordCloudList.push({
      name: row.name,
      value: wordTf,
      metricValue: choosenMetric,
      numberOfAds: wordOccurrences,
    });
  }
  return wordCloudList;
}

function getColorClusteringList(rows, xMetric, yMetric) {
  rows = rows.filter(r => r.cell[xMetric] && r.cell[yMetric]);
  let colorClusteringList = [];
  for (let row of rows) {
    const clusterColorHex = row.name;
    const clusterColorName = colorNamer(clusterColorHex).x11[0].name;
    let clusterSize;
    if (row.childQueries) {
      clusterSize = countUniqueChildQuery(row);
    } else {
      clusterSize = row.cell.clusterSize;
    }
    colorClusteringList.push({
      clusterColorHex,
      clusterColorName,
      clusterSize,
      xMetricValue: row.cell[xMetric],
      yMetricValue: row.cell[yMetric],
    });
  }
  return colorClusteringList;
}

function getEmojiAnalysisList(rows, xMetric, yMetric) {
  rows = rows.filter(r => r.cell[xMetric] && r.cell[yMetric]);
  let emojiAnalysisList = [];
  for (let row of rows) {
    let emojiSize;
    if (row.childQueries) {
      emojiSize = countUniqueChildQuery(row);
    } else {
      emojiSize = row.cell.emojiSize;
    }
    emojiAnalysisList.push({
      name: row.name,
      emojiSize,
      xMetricValue: row.cell[xMetric],
      yMetricValue: row.cell[yMetric],
    });
  }
  return emojiAnalysisList;
}

const getHeadersFromList = totalCell => {
  const metricColumns = totalCell.filter(cellName => {
    const [prefix, tracker] = cellName.split(':');

    return prefix && tracker
      ? prefix === 'custom-metric' ||
          (VALID_CONVERSION_PREFIX.includes(prefix) && TRACKER_LIST_FOR_FE.includes(tracker))
      : true;
  });

  return R.uniq([...COMMON_BASIC_COLUMNS_FOR_FE, ...metricColumns]);
};

const getHeadersFromListForWeb = totalCell => {
  const metricColumns = totalCell.filter(cellName => {
    return cellName.split(':').length > 1 ? R.any(v => R.includes(v, cellName), TRACKER_LIST_FOR_FE) : true;
  });

  return R.uniq([...COMMON_BASIC_COLUMNS_FOR_FE, ...metricColumns]);
};

function getRelatedAnalyticsMetrics({ analyticAccount, metrics }) {
  return (metrics || []).filter(
    metric =>
      metric.includes(analyticAccount.channel + ':') &&
      (metric.endsWith(':' + analyticAccount.name.replace(':', '')) ||
        analyticAccount.name.includes(metric.split(':').slice(-1)[0])),
  );
}

module.exports = {
  getMetricFromReport,
  getMetricAndConversionFromReport,
  mergeMetricAndConversion,
  getMetricAndConversions,
  getMetricValue,
  getCellType,
  getMetricType: getCellType,
  formatMetricValue,
  getComputedMetric,
  getComputedMetricFromReport,
  getConversionCellInfo,
  getMergedCellFromCampaigns,
  getMetricFormula,
  getMarketingSoueceMetricName,
  getWordCloudList,
  getColorClusteringList,
  getEmojiAnalysisList,
  getHeadersFromList,
  getHeadersFromListForWeb,
  getRelatedAnalyticsMetrics,
  getCustomSoueceMetricName,
};
